const PaymentTermEnum = new Map();

PaymentTermEnum.set(1, 'pay_at_buyer');
PaymentTermEnum.set(2, 'pay_at_grn');

export default PaymentTermEnum;
